/**
 * Findet heraus, ob ein Variable definiert ist
 * @param obj object to validate
 * @returns
 */
export const isDefined = (obj: unknown) =>
    typeof obj !== `undefined` && obj !== null;
